import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  BLITZ_QUIZ_PATH,
  BLITZ_QUIZ_ADD_PATH,
  BLITZ_QUIZ_UPDATE_PATH,
} from "utils/constants/paths";

const BlitzQuiz = Loadable(React.lazy(() => import("./View")));
const BlitzQuizAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const BlitzQuizRoute: IRouteItem = {
  path: BLITZ_QUIZ_PATH,
  iconName: "Flashy",
  element: React.createElement(BlitzQuiz),
  name: "Blitz Quiz",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: BLITZ_QUIZ_ADD_PATH,
      element: React.createElement(BlitzQuizAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: BLITZ_QUIZ_UPDATE_PATH,
      element: React.createElement(BlitzQuizAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
